export class Constants {

  static readonly  SYSTEM_USER = 'a9admp';

  static readonly DEAL_LIST = 'dealList';
  static readonly UPLOAD_URL = 'uploadFile';
  static readonly APP_CODE = 'cebq';
  // MONTHS
  static readonly MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  static readonly DATE_FORMAT_MMDDYYY = 'MM/dd/yyyy';
  static readonly DATE = 'DATE';
  static readonly SYBASE_SHORT_YEAR_MAX = '2078';
  static readonly LEGAL_YEAR_MIN = '1753';
  static readonly QUERY_SERV_NAME = 'QUERY_SERV_NAME';
  static readonly QUERY_LOAN_DETAILS = 'QUERY_LOAN_DETAILS';
  static readonly TRANSMISSION_KEY_LIST = 'GET_VIEW_TRANSMISSION_KEYS';
  static readonly GET_LOAN_DETAIL = 'GET_LOAN_DETAIL';
  static readonly GET_TRAN_QUERY_ALL_PKS = 'GET_TRAN_QUERY_ALL_PKS';
  static readonly GET_TRAN_QUERY_DATA_FOR_PKS = 'GET_TRAN_QUERY_DATA_FOR_PKS';
  static readonly GET_SERVICER_TRANSFER_LIST = 'GET_SERVICER_TRANSFER_LIST';
  static readonly LOAN_QUERY_KEY_LIST = 'GET_LOAN_QUERY_ALL_PKS';
  static readonly LOAN_QUERY_RESULT_LIST = 'GET_LOAN_QUERY_DATA_FOR_PKS';
  static readonly GET_TRAN_DETAIL = 'GET_TRAN_DETAIL';
  static readonly IS_SYSTEM_BAN_MSG_AVAIL = 'isSystemBannerMsgAvailable';
  static readonly IS_DELIVERY_SERVICING_BAN_MSG_AVAIL = 'isDeliveryServicingBannerMsgAvailable';
  static readonly IS_SERVICING_BAN_MSG_AVAIL = 'isServicingBannerMsgAvailable';
  static readonly IS_DELIVERY_BAN_MSG_AVAIL = 'isDeliveryBannerMsgAvailable';
  static readonly SERVICING_BAN_MSG = 'servicingBannerMsg';
  static readonly DELIVERY_BAN_MSG = 'deliveryBannerMsg';
  static readonly SYSTEM_MESSAGE = 'systemAvailabilityMessage';
  static readonly RM_MonthEndProcIndicatorMsg = 'deliveryServicingBannerMsg';
  static readonly RM_Indicator = 'RMAvailabilityIndicator';
  static readonly SYSTEM_INDICATOR = 'systemAvailabilityIndicator';
  static readonly ExternalSysAvailable = 'isExternalAccessAvailable';
  static readonly RM_ServicingSysAvailable = 'isServicingSysAvailable';
  static readonly RM_DeliverySysAvailable = 'isDeliverySysAvailable';
  static readonly FIELD_HDR_NAME = 'Field Name';
  static readonly CUR_HDR_VAL = 'Current Value';
  static readonly CUR_NEW_VAL = 'New Value';
  static readonly GNDR_M_VAL = 'Male';
  static readonly GNDR_F_VAL = 'FeMale';
  static readonly GNDR_MAL_STR = 'M';
  static readonly GNDR_FMAL_STR = 'F';
  static readonly TransTypeCode = '8';
  static readonly TrialBalTypeCode = '6';
  static readonly ServTransBalTypeCode = '7';
  static readonly UNEXPCT_ERROR = 'Unexpected Error. Try your request again.';
  static readonly APPROVE_SERVICER_TRANSFER_LIST = 'APPROVE_SERVICER_TRANSFER_LIST';
  static readonly DELETE_SERVICER_TRANSFER_LIST = 'DELETE_SERVICER_TRANSFER_LIST';
  static readonly GET_SERV_XFER_PARTIAL_LOAN_LIST_ALL_PKS = 'GET_SERV_XFER_PARTIAL_LOAN_LIST_ALL_PKS';
  static readonly GET_SERV_XFER_PARTIAL_LOAN_DATA_FOR_PKS = 'GET_SERV_XFER_PARTIAL_LOAN_DATA_FOR_PKS';
  static readonly DELETE_SERV_XFER_PARTIAL_LOAN = 'DELETE_SERV_XFER_PARTIAL_LOAN';
  static readonly GET_SELLER_SERVICER_INFO = 'GET_SELLER_SERVICER_INFO';
  static readonly INSERT_SERVICER_TRANSFER_LIST = 'INSERT_SERVICER_TRANSFER_LIST';
  static readonly REVERSE_MORTGAGE = 'reverseMortgage';
  static readonly RM_SERVICING = 'RMServicing';
  static readonly RM_DELIVERY = 'RMAcquisitions';
  static readonly DELETE_TRANSACTIONS = 'DELETE_TRANSACTIONS';
  static readonly GET_SUBMISSION_IDS = 'GET_SUBMISSION_IDS';
  static readonly SERVICER_TRANSFER_GET_LIST = 'SERVICER_TRANSFER_GET_LIST';


  //Error Messages
  static readonly ERROR_HEADER = 'You must correct the following error(s) before proceeding:';
  static readonly ERR_HEADER = 'Error - You must correct the following error(s) before proceeding:';
  static readonly HOL_ERR_MESS = 'Entered year must be 1994 or greater.';
  static readonly ATTR_VAL_EMPTY_MESS = 'Attribute value cannot be blank.';
  static readonly ATTR_VAL_LENGTH_EXCEED = 'Attribute value has exceeded the maximum length, Limit is 100 characters.';
  static readonly MAX_CLAIM_EMPT_MESS  = 'Please enter Max Claim Amount Value.';
  static readonly MAX_CLAIM_INCRT_FRMT_MESS  = 'MAX Claim Amount Value is in an incorrect format.';
  static readonly SOMETHING_MESS  = 'Something went wrong, Please try after sometime.';
  static readonly RSS_SUCCESS_MESS = 'Your RSS Remit transaction has been submitted successfully';
  static readonly RSS_FAIL_MESS = 'Failed to submit Your RSS Remit transaction.Pls Contact System administrator';
  static readonly UPDATE_PPA_SUCC_MESS = 'Loan record (Loan Number: {0}) has been successfully updated with the new field value';
  static readonly FAN_LN_NULL = 'Fannie Mae Loan Number can\'t be null.';
  static readonly PPA_LN_NUM_COU = '001B - Loan number must be 10 digits.';
  static readonly FAN_LN_INVLID = 'Loan Number: {0} is not a valid loan number.';
  static readonly PPA_MON_INCOM = '065B-Monthly Income cannot be greater than $999,999.99.';
  static readonly PPA_FHA_CAS_VAL = '015A-FHA Case Number Invalid.';
  static readonly PPA_ZIP_CODE_VAL = '020A-Property Zip Code must be 5 digits.';
  static readonly PPA_COBO_DATE_VAL =  '901-CoBorrower Birth Date - Not a valid date - Not a valid date.';
  static readonly PPA_NO_CHANGES_VAL =  'Please Change values before update';
  static readonly SEARCH_DATA_NOT_FOUND = 'Seasoned loan fee entry for seller number {0} and contract number {1} does not exist.';
  static readonly SEL_NUM_ERR = 'Seller Number must be 9 digits';
  static readonly SERV_NUM_ERR = 'Servicer Number should be numeric and 9 characters long.';
  static readonly FCH_CASE_NUM_ERR = 'FHA Case Number should be numeric and 10 characters long.';
  static readonly LOAN_NUM_ERR = 'Only the following sequence will qualify for Loan Number: "6" followed by 9 digits.';
  static readonly QUERY_LOAN_ERR = 'User must enter data into one of the following fields: Loan Number, FHA Case Number, LenderLoan Number or Servicer Number.';
  static readonly CON_NUM_ERR = 'Contract Number must be 6 digits';
  static readonly UPDT_SEASON_LOAN_MESS = 'Seasoned loan fees has been successfully added to the database.';
  static readonly ADD_SEASON_LOAN_MESS = 'Seasoned loan fees has been successfully added to the database.';
  static readonly ADD_SEASON_LOAN_EXCP_MESS = 'SeasonedLoanFees for the seller number and contract number is already present in the database.';
  static readonly DEL_SEASON_LOAN = 'Seasoned loan fee entry for seller number {0} and contract number {1} is deleted successfully.';
  static readonly SEL_UPLD_FILE = 'Please select a file to upload.';
  static readonly INVALID_FILE_TYPE = 'Invalid file type. Supported file types are .dat and .txt';
  static readonly INVALID_FILE_NAME_LENGTH = 'Invalid file name. File name can not exceed 46 characters';
  static readonly SELLER_NUM_VALID = 'Seller Number Must be Valid Number';
  static readonly SELLER_LENGTH_VALID = 'Seller Number Must be 9 digits';
  static readonly EMPTY_REPORT_DATE = 'Empty Reporting Date is not allowed';
  static readonly SEARCH_CRYSTALRpt127 = 'Please enter all the criteria for this report.';
  static readonly NO_ACTN_CD_SELECT = 'One or more action code must be selected';
  static readonly FN_LN_NO_RPT_DOWNLOAD = 'Fannie Mae Loan Number is not needed for download.';
  static readonly AT_LEAST_SRVR_OR_LN_NUM = 'At least one of Servicer Number and Fannie Mae Loan Number must be populated.';
  static readonly EMPTY_SUBMISSION_ID = 'Submission ID should be a number';
  static readonly SERVICER_ALL_OR_9_DIGITS = 'Servicer Number should be either ALL or 9 digits';
  //Constants
  static readonly SYS_ATTR_SYSBANNER = 'System Banner Message';
  static readonly SYS_ATTR_SRVCBANNER = 'Servicing Banner Message';
  static readonly SYS_ATTR_REVMORTBANNER = 'Reverse Mortgage Banner Message';
  static readonly SYS_ATTR_DELIVBANNER = 'Delivery Banner Message';

  static readonly DELIVERY_SYS_AVAILABLE = 'Delivery System Available';
  static readonly EBQ_SYS_AVAILABLE = 'eBoutique System Available';
  static readonly EXTRANAL_SYS_AVAILABLE = 'External System Available';
  static readonly REVERESE_MRT_SYS_AVAILABLE = 'Reverse Mortgage System Available';
  static readonly SERVICING_SYSTEM_AVAILABLE = 'Servicing System Available';

  static readonly No_LOAN_FUND_MSG = 'No Loans were found for the search criteria entered.';
  static readonly No_DATA_FOUND = 'No matching data found, please change your search criteria.';
  static readonly RESULT_WARNING = 'Your search will return over 500 records, please further define your search.';
  static readonly QUERY_SEARCH_TAKING_LONG_WARNING = 'Your search is taking too long, please narrow down your search criteria';
  static readonly MORE_RESULT_WARNING = 'Your search will return over 100 records, please further define your search.';
  static readonly SELLER_VALIDATION = 'Seller Number should be 9 digits';
  static readonly SERVICER_VALIDATION = 'Servicer Number should be 9 digits';
  static readonly CONTRACT_VALIDATION = 'Contract Number should be 6 digits';
  static readonly LENDERLOAN_VALIDATION = 'LenderLoan Number should be lesser than 15 digits';
  static readonly LOANNUMBER_VALIDATION = 'FNMA Loan Number should be 10 digits';
  static readonly USERID_VALIDATION = 'User ID contains invalid characters';
  static readonly USERID_SEARCH_VALIDATION = 'Search by user id contains Invalid characters';
  static readonly STATUS_VALIDATION = 'Status contains invalid characters';
  static readonly REQUIRED_FIELDS_VALIDATION = 'User must enter data into one of the following fields: {0} or {1}';
  static readonly NOT_VALID_LOAN_NUMBER = 'Only the following sequence will qualify for Loan Number: \'6\' followed by 9 digits.';
  static readonly INVALID_FORMAT = '{0} should be numeric and {1} characters long.';
  static readonly INVALID_CHARACTERS = '{0} contains invalid characters';
  static readonly NO_DATA_MESSAGE = 'Your query returned no data';
  static readonly LOAN_NUM_ERR_COUNT = '001B - Loan Number must be 10 digits..';
  static readonly EFF_DATE_EMPTY = '004D - Effective Date is a required field..';
  static readonly EFF_DATE_ERR_FORMAT = '004A - Effective Date must be a valid date. Correct format is MM/DD/YYYY..';
  static readonly EFF_DATE_YR_ERR_FORMAT = '004T - Payoff date must be prior to or within the current month. Please refer to the HUD calculator for future period payoffs..';
  static readonly EFF_DATE_GREATER_ERR_FORMAT = '004E - Submitted Tran-{0} $-{1} - Effective Date cannot be greater than Current Date..';
  static readonly PLS_RE_SUBMIT = 'Please resubmit your request or contact Production Support';
  static readonly REVERSE_MESSAGE = 'Do you really want to reverse this transaction?';
  static readonly LOAN_AMT_EMPTY_MESSAGE = '701A - Transaction Amount is invalid amount. Example 123.45 or -123.45.';
  static  readonly LINE_OF_CREDIT_FORMAT = '701A - Line Of Credit Reserve is invalid amount.  Example 123.45 or -123.45';
  static readonly  SCHEDULED_PAYMENT_FORMAT = '701A - Scheduled Payment Amount is invalid amount.  Example 123.45 or -123.45';
  static readonly  TRANSACTION_ASIDE_AMNT_FORMAT = '701A - Taxes And Insurance Set Aside Amount is invalid amount.  Example 123.45 or -123.45';
  static readonly  REMAING_TERM_GREATRE_ZERO = '007C - Term must be a number greater than or equal to 1.';
  static readonly  TRANS_ASIDE_PERCENT_VALID = '705A - Taxes And Insurance Set Aside Percent is invalid.';
  static readonly TAXES_AMNT_BEGIN_DATE_VALID = '011B - Taxes And Insurance Witholding From Date must be a valid date. Correct format is MM/DD/YYYY.';
  static readonly  TAXES_AMNT_END_DATE_VALID = '012B - Taxes And Insurance Witholding To Date must be a valid date. Correct format is MM/DD/YYYY.';
  static readonly  PAYMENT_PLAN_INVALID = 'Scheduled Payment contains invalid characters';
  static readonly PAYMENT_REASON_CHANGE_INVALID = 'Reason for Payment change contains invalid characters';
  static readonly GREATER_HTAN_ZERO = '014D - Amount must be greater than zero..';
  static readonly UPLOAD_PAGE_HEADER = 'Upload Reverse Mortgage File';
  static readonly SUCC_UPLOAD_PAGE_HEADER = 'Reverse Mortgage File Upload Status';
  static readonly LOAN_NOT_AVAIL = 'Loan is not present in the system or the loan data is not valid for the effective date.';
  static readonly USR_NOT_AUTH = '050A - User not authorized for servicer ';
  static readonly USR_NOT_AUTH_PERFORM = 'Not authorized to perform this transaction for Loan: {0}';
  static readonly SERVICER_NUM_REQUIRED = 'Servicer Number is Required.';
  static readonly SELLER_NUM_LENGTH = 'Seller Number shoud be a 9 digit number.';
  static readonly SELLER_NAME_REQUIRED = 'Seller Contact Name is Required.';
  static readonly SELLER_NAME_FORMAT = 'Seller Contact Name cannot be a number.';
  static readonly SELLER_PHONE_REQUIRED = 'Seller Contact Phone is Required.';
  static readonly SELLER_PHONE_LENGTH = 'Seller Contact Phone should be a 10 digit number.';
  static readonly SELLER_FAX_REQUIRED = 'Seller Contact Fax is Required.';
  static readonly SELLER_FAX_LENGTH = 'Seller Contact Fax should be a 10 digit number.';

  static readonly SERVICER_NUM_LENGTH = 'Servicer Number shoud be a 9 digit number.';
  static readonly SERVICER_NAME_REQUIRED = 'Servicer Contact Name is Required.';
  static readonly SERVICER_NAME_FORMAT = 'Servicer Contact Name cannot be a number.';
  static readonly SERVICER_PHONE_REQUIRED = 'Servicer Contact Phone is Required.';
  static readonly SERVICER_PHONE_LENGTH = 'Servicer Contact Phone should be a 10 digit number.';
  static readonly SSERVICER_FAX_REQUIRED = 'Servicer Contact Fax is Required.';
  static readonly SERVICER_FAX_LENGTH = 'Servicer Contact Fax should be a 10 digit number.';
  static readonly  TRIALBAL_ERR_FORMAT = '{0} is in an incorrect format';
  static readonly VIEW_PURCHASE_ADVICE_ERR = 'Invalid search combination, please try again.';
  static readonly NO_RETURNED_DATA = 'Your query returned no data.Please change the search criteria and try again.';
  static readonly MONTHLY_REPORT = 'Monthly Report';
  static readonly DAILY_REPORT = 'Daily Report';

  static readonly LOAN_NOT_ACTIV = '001A - Loan must be an active loan..';
  static readonly USER_DETAILS = {
    firstName: 'EBTQ',
    lastName: 'Test Three',
    middleInitial: '',
    fmFederationID: 'I200025622',
    mail: 'ebtq_test_three@fanniemae.com',
    telephoneNumber: '',
    sub: 'fkuv1u54',
    uid: 'fkuv1u54',
    department: '',
    division: '',
    employeeNumber: '972128',
    employeeType: 'Application ID/Test',
    fmCostCenter: '879',
    fmManagerLevel: '',
    fmbusinessunit: '',
    isInternalUser: true,
    location: 'WWRO',
    streetAddress: '',
    title: '',
    isExternalUser: '',
    subscriberName: '',
    userType: '',
    corporateFamilyCode: '',
    institutionIdDefault: '',
    institutionNameDefault: '',
    mornetID: '',
    mornetParntSubscrberId: '',
    primaryKeySubcriberId: '',
    sellerServicerCoNo: '',
    subscriberMplusId: '',
    ultimateParntSubscrberId: '',
    groups: ['SG-A9-DEVL-EBOUTIQUE-Developer', 'SG-A9-DEVL-EBOUTIQUE-Admin'],
    emailAddress: 'ebtq_test_three@fanniemae.com',
    workNumber: '',
    mobileNumber: '',
    userName: 'fkuv1u54',
    isFannieMaeUser: true,
    dealerOrgName: '',
    institutionId: '',
    customerName: '',
    dealerOrgId: '',
    mornetPlusId: '',
    parentId: '',
    authorizedServicers :[]
  };


  /* Roles Constants */
  static readonly ADMIN_ROLE = 'SG-GJU-ENVIRONMENT-EBOUTIQUE-AWS-Admin';

  static readonly ADMIN_A9_ROLE = 'SG-A9-ENVIRONMENT-EBOUTIQUE-Admin';

  static readonly DEV_ROLE = 'SG-GJU-ENVIRONMENT-EBOUTIQUE-AWS-Developer';

  static readonly DEV_A9_ROLE = 'SG-A9-ENVIRONMENT-EBOUTIQUE-Developer';

  static readonly RMINT_VIEW_ROLE = 'SG-GJU-ENVIRONMENT-EBOUTIQUE-AWS-RMInternalView';

  static readonly RMINT_VIEW_A9_ROLE = 'SG-A9-ENVIRONMENT-EBOUTIQUE-RMInternalView';

  static readonly RMINT_UPDATE_ROLE = 'SG-GJU-ENVIRONMENT-EBOUTIQUE-AWS-RMInternal';

  static readonly RMINT_UPDATE_A9_ROLE = 'SG-A9-ENVIRONMENT-EBOUTIQUE-RMInternal';

  static readonly SERV_VIEW_ROLE = 'EBOUTIQ_ServicingExternalView';

  static readonly SERV_UPDATE_ROLE = 'EBOUTIQ_ServicingExternalUpdate';

  static readonly DELIVERY_UPDATE_ROLE = 'EBOUTIQ_DeliveryExternalUpdate';

  static readonly DELIVERY_VIEW_ROLE = 'EBOUTIQ_DeliveryExternalView';

}
